import React from 'react';
import {
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { connect } from "react-redux";
import ArchiveHeader from "../../../components/ArchiveHeader";
import ContactForm from './form';
import { injectIntl } from "react-intl";

const Contact = ({userProfile, intl, locale, setLocale}) => {
  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="link.contact" />
      <div className="pad-2rem contact-page align-items-center">
        <Container fluid className="h-100">
          <Row className="align-items-center h-100">
            <Col md={8} lg={6} xl={4} className="mx-auto">
              <ContactForm email={userProfile.email} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  userProfile: state.user.profile
});

export default connect(mapStateToProps)(injectIntl(Contact));